import headerImg from '../../../assets/serviceHeader.svg'

import img1 from '../../../assets/dummy1.avif'
import img2 from '../../../assets/dummy2.avif'
import img3 from '../../../assets/dummy3.avif'

import backend from '../../../assets/services-web-App/backend.svg'
import frontend from '../../../assets/services-web-App/frontend.svg'
import product from '../../../assets/services-web-App/product.svg'
import quality from '../../../assets/services-web-App/quality.svg'

import support from '../../../assets/services-web-App/support.svg'
import prototype from '../../../assets/services-web-App/prototype.svg'
import planning from '../../../assets/services-web-App/planning.svg'
import devops from '../../../assets/services-web-App/devops.svg'
import deployment from '../../../assets/services-web-App/deployment.svg'

import enterprise from '../../../assets/services-web-App/enterprise.svg'
import webConsulting from '../../../assets/services-web-App/web-consulting.svg'
import cloudBased from '../../../assets/services-web-App/cloud-based.svg'
import progressive from '../../../assets/services-web-App/progressive.svg'
import supplyChain from '../../../assets/services-web-App/supply-chain.svg'

import decision from '../../../assets/services-web-App/decision.svg'
import experience from '../../../assets/services-web-App/experience.svg'
import problemSolver from '../../../assets/services-web-App/problemSolver.svg'

import img from '../../../assets/services/img.svg'


import myimg1 from '../../../assets/services-web-App/tech/img1.svg'
import myimg2 from '../../../assets/services-web-App/tech/img2.svg'
import myimg3 from '../../../assets/services-web-App/tech/img3.svg'
import img4 from '../../../assets/services-web-App/tech/img4.svg'
import img5 from '../../../assets/services-web-App/tech/img5.svg'
import img6 from '../../../assets/services-web-App/tech/img6.svg'
import img7 from '../../../assets/services-web-App/tech/img7.svg'
import img9 from '../../../assets/services-web-App/tech/img9.svg'
import img10 from '../../../assets/services-web-App/tech/img10.svg'
import img11 from '../../../assets/services-web-App/tech/img11.svg'
import img12 from '../../../assets/services-web-App/tech/img12.svg'
import img13 from '../../../assets/services-web-App/tech/img13.svg'
import img14 from '../../../assets/services-web-App/tech/img14.svg'
import img15 from '../../../assets/services-web-App/tech/img15.svg'
import img16 from '../../../assets/services-web-App/tech/img16.svg'
import img17 from '../../../assets/services-web-App/tech/img17.svg'
import img18 from '../../../assets/services-web-App/tech/img18.svg'
import img19 from '../../../assets/services-web-App/tech/img19.svg'
import img20 from '../../../assets/services-web-App/tech/img20.svg'
import img22 from '../../../assets/services-web-App/tech/img22.svg'
import img23 from '../../../assets/services-web-App/tech/img23.svg'
import img24 from '../../../assets/services-web-App/tech/img24.svg'

import review from '../../../assets/dummyreview.png'

import seo from '../../../assets/seo.jpg'
import ukrine from '../../../assets/ukrine.jpg'
import world from '../../../assets/america.jpg'
import famous from '../../../assets/famous.jpg'
import myimg from '../../../assets/myimg.jpg'


export const headerData = {
    title1: 'Custom Content Writing ',
    title2: 'Development Services',
    desc: 'We are a leading custom Content Writing  development company that creates scalable Content Writing  with high-quality standards. Thoroughly examining your preferences, requirements and expectations, our community of 500+ developers deliver top-notch web app development services to enhance your customer retention and boost brand equity. Have a look at our customer-centric services:',
    points: [
        'Daily collaborative meetings with product managers',
        'Free full-cycle quality assurance',
        'Wallet-friendly engagement models to hire developers'
    ],
    img: headerImg
}

export const BenefitsData = {
    title1: 'Kickstart Your Project with Our Personalized',
    title2: 'Content Writing  Development Services',
    desc: 'As the leading and trusted development company all over the world, we offer a personalized package of value-added services.',
    cards: [

        {
            title: 'Full Transparency',
            desc: 'Track the progress of the best web application development process with ease. A daily meeting with our product managers will keep you in the loop, treating your feedback as a valuable insight to deliver a bug-free final product.'
        },
        {
            title: 'Community of large Tech Veterans',
            desc: 'Codezone has hands-on expertise in web application development services and a thriving community of large developers that have achieved 97% client satisfaction across sectors such as Healthcare, Fintech, and more!'
        },
        {
            title: 'Specialized in Most Advanced Tech Stack',
            desc: 'Utilize the expertise of our proficient developers who have a strong grasp on the most popular programming languages, frameworks, databases, and other toolkit suites.'
        },
        {
            title: '100% Confidentiality As Promised',
            desc: 'You may be confident in the secrecy of your project! Our web app development team prioritizes cutting-edge technology and techniques to safeguard your data and other essential information.'
        },
    ]
}


export const recentworkdata = {
    title1: 'Our Recent',
    title2: 'Work',
    sliderData: [
        {
            title: 'Famous Youtuber',
            img: [famous],
            desc: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit adipisci blanditiis dignissimos culpa quod pariatur nulla officiis tempore, illo quis porro facilis iure consequatur at minima nostrum eveniet quam repellat!',
            link: 'https://drive.google.com/file/d/1nB_riiwaY5RUgfXEa1cbYIIvPM90n90Z/view?usp=share_link'

        },
        {
            title: 'Company SEO Services',
            img: [seo],
            desc: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit adipisci blanditiis dignissimos culpa quod pariatur nulla officiis tempore, illo quis porro facilis iure consequatur at minima nostrum eveniet quam repellat!',
            link: 'https://drive.google.com/file/d/1ij-fpjA8V_QJqlJFT8PvkPrchjmLfYaP/view?usp=share_link'

        },
        {
            title: 'American Wine History',
            img: [world] ,
            desc: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit adipisci blanditiis dignissimos culpa quod pariatur nulla officiis tempore, illo quis porro facilis iure consequatur at minima nostrum eveniet quam repellat!',
            link: 'https://docs.google.com/document/d/1XIA2uHX4XZeRY2PC6_MFWWkSrbS3oZUR/edit?usp=share_link&ouid=117032678046234679249&rtpof=true&sd=true'

        },
        {
            title: 'Ukraine Russia Invasion',
            img: [ukrine],
            desc: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit adipisci blanditiis dignissimos culpa quod pariatur nulla officiis tempore, illo quis porro facilis iure consequatur at minima nostrum eveniet quam repellat!',
            link: 'https://drive.google.com/file/d/1FcmByz1m41qZHumLGVheJVR_lxI-df-4/view?usp=share_link'

        },
        {
            title: 'The Spiritual Balance',
            img: [myimg],
            desc: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit adipisci blanditiis dignissimos culpa quod pariatur nulla officiis tempore, illo quis porro facilis iure consequatur at minima nostrum eveniet quam repellat!',
            link: 'https://drive.google.com/file/d/1fxOJCit_h8CgXrGVhPqWTCPWHs_665hE/view?usp=share_link'

        },

    ]
}

export const SuccessDrivenData = {
    title1: 'Build A Success-Driven Development Team To',
    title2: 'Protect Your Project Scope',
    desc: 'Prevent scope creep, frequent delays and unplanned changes by building a development team. Here’s what a success-driven development team looks like.',
    cards: [
        {
            title: 'Conveys Informations',
            desc: "An ebook cover can give readers an idea of what the ebook is about, including the genre, tone, and message.",
            img: frontend
        },
        {
            title: 'Sets Expectations',
            desc: "A high-quality ebook cover can set readers' expectations for the quality of the writing and the overall reading experience.",
            img: backend
        },
        {
            title: 'Increases Sales',
            desc: 'A compelling ebook cover can lead to more sales, as readers are more likely to purchase an ebook that looks professional and engaging.',
            img: product
        },
    ]
}

export const developmentProcessData = {
    title1: 'A Snapshot Of Our Content Writing ',
    title2: 'Development Process',
    desc: "Plan, design, develop, test and roll out each version of your web application with zero downtime.",
    processNames: ['Planning', 'Design', 'Prototype', 'Development', 'Software Quality Assurance', 'DevOps Services', 'Support & Maintenance'],
   processInfo : [
    {
        title: 'Planning',
        desc: 'Outline all procedures and activities necessary to ensure project success and develop a complete set of plans to manage the project from this phase till project completion. It provides a clear structure of scope, deliverables, processes, budget, tech stack and timeline.',
        img: planning,
        link : '/contact-us'
    },
    {
        title: 'Design',
        desc: 'To create a marketable product, refine your ideas through market research validation. Save expenses and eliminate risks by working with our focused web application development team that moves smoothly through numerous iterations and launches high-functioning prototypes via a streamlined MVP development approach.',
        img: prototype,
        link : '/ui-ux-design'
    },
    {
        title: 'Development',
        desc: 'With our well-established bespoke web application development services, your brand will stand out from the crowd. Build safe, scalable, accessible, and custom software solutions with our specialized SCRUM team - tailored to your firm’s specifications and market expectations.',
        img: deployment,
        link : '/'

    },
    {
        title: 'Software Quality Assurance',
        desc: 'Reduce errors in your codes and interfaces with our automated software quality assurance geared toward higher ROI. To provide the greatest experience for your consumers, we use fine-tuned tools and construct sturdy walls with our penetration testing services.',
        img: quality,
        link : '/hire-sqa-engineers'

    },
    {
        title: 'DevOps Services',
        desc: 'With our well-engineered DevOps services, you can transition to continuous delivery and ensure durable data pipelines and speedier time-to-market. We integrate your existing infrastructure into a strong ecosystem using agile approaches while maintaining software quality.',
        img: devops,
        link : '/hire-sqa-engineers'

    },
    {
        title: 'Support & Maintenance',
        desc: "Deliver high-performance software to your customers by choosing our advanced web app development strategy, which includes bug-fixing, on-call production support, product improvements, user support, and training. Use Codezone's qualified personnel to optimize the functionalities of your product.",
        img: support,
        link : '/software-development'

    },
]
}

export const DevelopmentServicesData = {
    title1: 'A Wide Range of Content Writing ',
    title2: 'Development Services',
    desc: 'Light years ahead of our competitors, CodeZone offers Content Writing  development services and uses the latest technologies that will compel your customers to spend lavishly on your products.',
    cards: [
        {
            title: 'Marketing',
            desc: 'Content writing is often used in marketing to create content that attracts, engages, and converts potential customers. This includes blog posts, social media content, email campaigns, and more.',
            img: supplyChain
        },
        {
            title: 'Public Relations',
            desc: 'Content writing is often used in public relations to create press releases, speeches, and other communication materials that promote a brand or individual.',
            img: progressive
        },
        {
            title: 'Marketing and Advertising',
            desc: 'Ebook covers are an essential part of any book marketing campaign, as they are used to promote the book on social media, online marketplaces, and other platforms.',
            img: enterprise
        },
        {
            title: 'Creative Writing',
            desc: 'Content writing can be used in creative writing, such as in the creation of novels, short stories, and other types of literature.',
            img: webConsulting
        },
        {
            title: 'Technical Writing',
            desc: 'Content writing is used in technical writing to create manuals, user guides, and other technical documents that explain how to use a product or service.',
            img: cloudBased
        },

    ]
}
export const hireWebData = {
    title1: 'Hire Content Writing  Developers To Extend',
    title2: 'The Roots of Your Business',
    desc: 'Get ready to elevate the performance and extend the functionalities of your metaverse by hiring our web application developers today!',
    questions: [
        {
            question: 'Good Decision-Making Skills',
            answer: 'Identify project risks and threats by leveraging the experience and technical expertise of our metaverse developers. They have the skills to predict trends and mitigate difficulties.',
            img: decision
        },
        {
            question: 'Enriched Experience',
            answer: 'Our senior Content Writing  developers, with over 10,000 hours of work on diverse web app development projects, have faced several obstacles, which gives them a broader worldview while presenting answers. Their experiences also provide them with new perspectives on how to approach a project.',
            img: experience
        },
        {
            question: 'Problem Solvers & Risk Managers',
            answer: "Identify project risks and threats by leveraging the experience and technical expertise of our metaverse developers. They have the skills to predict trends and mitigate difficulties.",
            img: problemSolver
        },
    ]
}

export const ModelData = {
    title1: 'A Glance At Our Customer-Centric',
    title2: 'Engagement Models',
    desc: 'Choose a business engagement model that best fits your preferences.',
    img,
    tags: ['Resource Augmentation', 'Dedicated Team', 'Fixed Gig']
}

export const techData = {
    title1: 'Our Favorite Folder Of The',
    title2: 'Technologies We Use',
    images: [
        myimg1,
        myimg2,
        myimg3,
        img4,
        img5,
        img6,
        img7,
        img9,
        img10,
        img11,
        img12,
        img13,
        img14,
        img15,
        img16,
        img17,
        img18,
        img19,
        img20,
        img22,
        img23,
        img24,


    ]
}

export const reviewData = {
    title1: 'Cultivating Long-Term',
    title2: 'Relationships',
    sliderData: [
        {
            img: 'https://images.unsplash.com/photo-1629393587517-19cd2e98b2b0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fHVzYSUyMGZsYWd8ZW58MHx8MHx8&w=1000&q=80',
            desc: 'CodeZone always provides excellent quality of work. Very Proactive to Client needs',
            rating: 5,
            country: 'USA'
        },
        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTedMEhnYyMDXrmPyu68m32qbRkDG0bUKS0Q&usqp=CAU',
            desc: "Creative, responsive and energetic to bring my story to life. I'm blown away. Thank you so much for doing the excellent job for me. Excellent communication and fast deleivery.",
            rating: 5,
            country: 'Canada'

        },
        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBsiNMALQdlyt5FBexnrC4CBM9IJWEM8MWuQ&usqp=CAU',
            desc: 'Very thorough and well documented. I highly recommend',
            rating: 5,
            country: 'Australia'
        },
        {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ5ZqPb_f2km0YhmGLSfpFWt9w4INHiwJ3T2Q&usqp=CAU',
            desc: 'This was my first experience working with CodeZone and he exceeded my expectations in every way. He created a nice and interesting story. He was very kind, responsive and prepared to listen adn follow my instructions. Truly professional. 100% recommended. Thank you a lot',
            rating: 5,
            country: 'UK'
        },

    ]
}

export const FAQData = [
    {
        question: 'What is content writing?',
        answer: 'Content writing refers to the creation of written content that is used for various purposes such as marketing, education, public relations, and more.'
    },
    {
        question: 'What skills are required for content writing?',
        answer: "Content writers should have strong writing skills, research skills, and knowledge of grammar and syntax. Additionally, they should be able to adapt their writing style to different audiences and have a good understanding of SEO."
    },
    {
        question: 'How can content writing help a business grow?',
        answer: "Content writing can help businesses grow by attracting and engaging potential customers, increasing website traffic, improving search engine rankings, building brand awareness, and establishing the business as an industry thought leader."
    },
]